/**
 * Helpers Functions
 */
import moment from "moment";
import * as Sentry from "@sentry/browser";
import { unmarshall, convertToAttr, convertToNative } from "@aws-sdk/util-dynamodb";
import { NotificationManager } from "react-notifications";

/**
 * Function to convert hex to rgba
 */
export function hexToRgbA(hex, alpha) {
  var c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    return (
      "rgba(" +
      [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
      "," +
      alpha +
      ")"
    );
  }
  throw new Error("Bad Hex");
}

/**
 * Text Truncate
 */
export function textTruncate(str, length, ending) {
  if (length == null) {
    length = 100;
  }
  if (ending == null) {
    ending = "...";
  }
  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending;
  } else {
    return str;
  }
}

/**
 * Get Date
 */
export function getTheDate(timestamp, format) {
  let time = timestamp * 1000;
  let formatDate = format ? format : "MM-DD-YYYY";
  return moment(time).format(formatDate);
}

/**
 * Convert Date To Timestamp
 */
export function convertDateToTimeStamp(date, format) {
  let formatDate = format ? format : "YYYY-MM-DD";
  return moment(date, formatDate).unix();
}

/**
 * Function to return current app layout
 */
export function getAppLayout(url) {
  let location = url.pathname;
  let path = location.split("/");
  return path[1];
}



/**
 *  Error handling
 *
 * @export
 * @param {*} error
 * @param {*} options
 */
export function errorHandling(error, options) {
  console.log("ERROR HANDLER LOG", error, options);
  if (error.message) {
    Sentry.captureException(error, options);
  } else if (error.errors) {
    for (let err of error.errors) {
      Sentry.captureException(new Error(err.message));
      if (err.message) {
        NotificationManager.error(err.message);
      }
    }
  } else {
    Sentry.captureException(error, options);
  }
}
export function handleCompanyStaff(recordID: String): String {
  return recordID;
}
/**
 * @param {Object} objectToClean
 * @param {Array} listOfProperties
 * @memberof NewWarehouseReceipt
 */
export function cleanObject(objectToClean, listOfProperties) {
  while (listOfProperties.length > 0) {
    let property = listOfProperties.pop();
    // console.log("Keys TO CLEAN", property);
    let value = objectToClean[property];
    // console.log("VALUE TO CLEAN", value);
    if (value && typeof value === "object" && value.length > 0) {
      objectToClean[property] = cleanObject(
        objectToClean[property],
        Object.keys(objectToClean[property])
      );
    } else if (
      objectToClean[property] === null ||
      objectToClean[property] === "" ||
      Number.isNaN(objectToClean[property]) ||
      objectToClean[property].length === 0
    ) {
      delete objectToClean[property];
    }
  }
  return objectToClean;
}

export function formatPreferences(preferences: Array): Object {
  let _preferences = {};
  console.log("FORMAT PREFERENCES", preferences)
  try {
    preferences.forEach((pref: Object) => {
      let tempDynamoData = {};
      if (!pref.dataValue.includes("NULL")) {
        if (pref.dataValue.includes("BOOL")) {
          pref.dataValue = convertToNative(JSON.parse(pref.dataValue))
        } else {
          tempDynamoData.dataValue = JSON.parse(pref.dataValue);
        }
      } else {
        pref.dataValue = true;
      }
      if (!pref.dataDefault.includes("NULL")) {
        if (pref.dataDefault.includes("BOOL")) {
          pref.dataDefault = convertToNative(JSON.parse(pref.dataDefault))
        } else {
          tempDynamoData.dataDefault = JSON.parse(pref.dataDefault);
        }
      } else {
        pref.dataDefault = true;
      }
      console.log("UNMARSHALLED DATAVALUE", tempDynamoData)
      if (Object.keys(tempDynamoData).length > 0) {
        let parsedDynamo = unmarshall(tempDynamoData);
        console.log("PARSED DYNAMO", parsedDynamo);
        if (parsedDynamo.dataDefault) {
          pref.dataDefault = parsedDynamo.dataDefault;
        }
        if (parsedDynamo.dataValue) {
          pref.dataValue = parsedDynamo.dataValue;
        }
      }
      _preferences[pref.name] = pref;
    });

    return _preferences;
  } catch (error) {
    errorHandling(error);
    return error;
  }
}
/**
 * Validate URL param
 * @param {String} param Base64 encoded ID
 * @param {String} match expected String to match
 * @returns {Boolean} OK
 *
 */
export function validateParams(param, match) {
  try {
    let paramString = window.atob(param).split("-");
    if (match === "WorkOrderTask") {
      paramString = window.atob(param).split(":");
    }
    if (paramString[0] === match) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
}
/**
 * Gives us the status of the promise. This is used to send async requests
 * and determine which query returned values first.
 * PromiseID lets us know which promise resolved successfully letting us know the
 * message to show the user
 *
 * Usage: This is due to GQL responses
 * coming through 504 Cloudfront errors
 *
 * PromiseID of "FALLBACK_DATA" delays promises by 5 seconds
 * and has the least amount of information for the request made
 *
 * PromiseID of "COMPLETE_DATA" is the request with all of it's
 * data nodes
 *
 * @param {Promise} promise
 * @param {String} pid PromiseID
 * @memberof StockDAO,WarehouseReceiptDAO
 */
export function MakeQuerablePromise(promise, pid) {
  // Don't modify any promise that has been already modified.
  if (promise.isResolved) {
    return promise;
  }

  // Set initial state
  var isPending = true;
  var isRejected = false;
  var isFulfilled = false;
  // Observe the promise, saving the fulfillment in a closure scope.
  if (pid === "FALLBACK_DATA") {
    var result = promise.delay(5000).then(
      v => {
        isFulfilled = true;
        isPending = false;
        v["pid"] = pid;
        return v;
      },
      e => {
        isRejected = true;
        isPending = false;
        throw e;
      }
    );
  } else {
    // eslint-disable-next-line no-redeclare
    var result = promise.then(
      v => {
        isFulfilled = true;
        isPending = false;
        v["pid"] = pid;
        return v;
      },
      e => {
        isRejected = true;
        isPending = false;
        throw e;
      }
    );
  }

  result.isFulfilled = function() {
    return isFulfilled;
  };
  result.isPending = function() {
    return isPending;
  };
  result.isRejected = function() {
    return isRejected;
  };
  return result;
}

function delay(t, v) {
  return new Promise(resolve => {
    setTimeout(resolve.bind(null, v), t);
  });
}
/**
 * Checks whether or not the object in question has no values.
 * @param {Object} obj
 */
export function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
}
Promise.prototype.delay = function(t) {
  return this.then(v => {
    return delay(t, v);
  });
};

/**
 * Checks if the input string is an email
 *
 * @param {String} email
 * @returns {Boolean}
 * @memberof Auth
 */
export function validEmail(email) {
  return (
    email.match(/^[\w.!#$%&’*+/=?^_`{|}~-]+@[\w-]+(?:\.[\w-]+)+$/) !== null
  );
}
/**
 * Retrieve the key of an object by it's value
 * @param {Object} object
 * @param {any} value
 */
export function getKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] === value);
}
/**
 * Date constructor cannot handle the string to be direct date. Must be
 * broken down to individual date values
 * @param {String} date "YYYY-MM-DD"
 * @returns
 */
export function parseYYYYMMDD(date) {
  let dateArr = date.split("-");
  const parsedDate = new Date(dateArr[0], parseInt(dateArr[1]) - 1, dateArr[2]);
  return parsedDate;
}
/**
 * Create delay in async await Promise
 * @param {int} ms
 * @returns
 */
export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
